import script from "./RangePickerComp.vue?vue&type=script&setup=true&lang=js"
export * from "./RangePickerComp.vue?vue&type=script&setup=true&lang=js"

import "./RangePickerComp.vue?vue&type=style&index=0&id=1cb55a07&lang=css"

const __exports__ = script;

export default __exports__